"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowhightExtremhighOutlined = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.RowhightExtremhighOutlined = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M9 2.75C9 2.05964 9.55964 1.5 10.25 1.5H13.25C13.9404 1.5 14.5 2.05964 14.5 2.75V13.25C14.5 13.9404 13.9404 14.5 13.25 14.5H10.25C9.55964 14.5 9 13.9404 9 13.25V2.75ZM10.5 3V13H13V3H10.5Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }),
            react_1.default.createElement("path", { d: "M5.5 4.06066L6.46967 5.03033C6.76256 5.32322 7.23744 5.32322 7.53033 5.03033C7.82322 4.73744 7.82322 4.26256 7.53033 3.96967L5.28033 1.71967C4.98744 1.42678 4.51256 1.42678 4.21967 1.71967L1.96967 3.96967C1.67678 4.26256 1.67678 4.73744 1.96967 5.03033C2.26256 5.32322 2.73744 5.32322 3.03033 5.03033L4 4.06066V11.9393L3.03033 10.9697C2.73744 10.6768 2.26256 10.6768 1.96967 10.9697C1.67678 11.2626 1.67678 11.7374 1.96967 12.0303L4.21967 14.2803C4.51256 14.5732 4.98744 14.5732 5.28033 14.2803L7.53033 12.0303C7.82322 11.7374 7.82322 11.2626 7.53033 10.9697C7.23744 10.6768 6.76256 10.6768 6.46967 10.9697L5.5 11.9393V4.06066Z", fill: colors[0] }));
    },
    name: 'rowhight_extremhigh_outlined',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M9 2.75C9 2.05964 9.55964 1.5 10.25 1.5H13.25C13.9404 1.5 14.5 2.05964 14.5 2.75V13.25C14.5 13.9404 13.9404 14.5 13.25 14.5H10.25C9.55964 14.5 9 13.9404 9 13.25V2.75ZM10.5 3V13H13V3H10.5Z', 'M5.5 4.06066L6.46967 5.03033C6.76256 5.32322 7.23744 5.32322 7.53033 5.03033C7.82322 4.73744 7.82322 4.26256 7.53033 3.96967L5.28033 1.71967C4.98744 1.42678 4.51256 1.42678 4.21967 1.71967L1.96967 3.96967C1.67678 4.26256 1.67678 4.73744 1.96967 5.03033C2.26256 5.32322 2.73744 5.32322 3.03033 5.03033L4 4.06066V11.9393L3.03033 10.9697C2.73744 10.6768 2.26256 10.6768 1.96967 10.9697C1.67678 11.2626 1.67678 11.7374 1.96967 12.0303L4.21967 14.2803C4.51256 14.5732 4.98744 14.5732 5.28033 14.2803L7.53033 12.0303C7.82322 11.7374 7.82322 11.2626 7.53033 10.9697C7.23744 10.6768 6.76256 10.6768 6.46967 10.9697L5.5 11.9393V4.06066Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
